import { firebase } from '../config/firebase.client';

export const RequestPushMsg = (token, data) => {
    const {
        config
    } = firebase;

    let host = `https://us-central1-${config.projectId}.cloudfunctions.net`;


    let url = `${host}/send_notification`;

    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            "token": token,
            ...data
        })
    })
        .then((response) => {
        })
        .catch((error) => {
            console.error(error)
        });
}